// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

const TertiaryTitle = styled.h2`
  ${({ theme }) => theme.typography.type201};
  margin: ${({ theme }) => `0 0 ${theme.spacing.spacing20} 0`};
  color: ${({ theme }) => theme.colors.textPrimary};

  @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.subTitleLarge};
  }
`;

export default TertiaryTitle;
